const zh_tw = require("./apexLocales/zh-tw.json")
export default class CONST {

  static crossRegionOption = {
      chart: {
        defaultLocale: 'zh-tw',
        type: 'bar',
        stacked: true,
        height: 350,
        toolbar: {
          show: true, // show/hide download button on apexcharts
        },
        zoom: {
          enabled: false, // show/hide zoom button on apexcharts
        },
        locales: [zh_tw],
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
      },
      yaxis: {
        title: {
          rotate: -90,
          text: '推估人數'
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return  val + "位"
          }
        }
      }
  } 
}